import React from 'react';
import { useSelector } from 'react-redux';
import { Stack, Typography, Button, Link as MuiLink } from '@mui/material';
import { RootState } from '../../../../../../utils/redux_store/store';

interface PrivacyNoticeModalProps {
  setModalContent: (content: number) => void;
  isPractice: boolean;
}

export const PrivacyNoticeModal: React.FC<PrivacyNoticeModalProps> = ({
  setModalContent,
}) => {
  const companyName = useSelector((state: RootState) => state.logo.companyName);

  const handleApply = () => {
    // Both practice and real should proceed to hardware check/setup
    setModalContent(2);
  };

  const handleDecline = () => {
    // Return to list
    setModalContent(0);
  };

  return (
    <Stack spacing={3} sx={{ width: '100%' }}>
      <Typography variant='h6' fontWeight={700}>
        Privacy Notice
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ lineHeight: 1.6 }}>
        Our site collects and stores information about you. More details about
        what we collect is found in our{' '}
        <MuiLink
          href='https://www.hiacuity.com/privacy-policy'
          target='_blank'
          rel='noopener noreferrer'
          underline='hover'
          fontWeight={600}
        >
          privacy policy
        </MuiLink>
        .
        <br />
        Please click the Accept All button if you agree to having your data
        collected and stored by{' '}
        <Typography component='span' variant='body2' fontWeight={600} color='primary.main'>
          {companyName || 'our platform'}
        </Typography>
        .{' '}
        If you do not agree, please click the Decline All button.
      </Typography>

      <Stack
        direction='row'
        spacing={2}
        justifyContent='flex-end'
        sx={{ pt: 2, borderTop: 1, borderColor: 'divider' }}
      >
        <Button
          variant='outlined'
          color='inherit'
          onClick={handleDecline}
        >
          Decline All
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={handleApply}
        >
          Accept All
        </Button>
      </Stack>
    </Stack>
  );
};
